export default "__VITE_ASSET__BCrpOTIE__"